export interface ComicItem {
  id: number;
  title: string;
  category: string;
  tags: string[];
  summary: string;
  cover: string;
  status: string;
  updateTime: string;
  followers: string;
  episodes: number;
  rating: number;
  tagColor: string;
}

export const comicCategories = [
  { key: "全部", icon: "ri-sparkling-2-fill", color: "bg-primary-500 text-background-50" },
  { key: "恶搞反转", icon: "ri-refund-2-fill", color: "bg-accent-500 text-foreground-950" },
  { key: "神展开", icon: "ri-question-mark", color: "bg-secondary-500 text-background-50" },
  { key: "脑洞大开", icon: "ri-lightbulb-flash-fill", color: "bg-primary-600 text-background-50" },
  { key: "魔性沙雕", icon: "ri-emotion-laugh-fill", color: "bg-accent-600 text-foreground-950" },
  { key: "爆笑日常", icon: "ri-movie-2-fill", color: "bg-secondary-600 text-background-50" },
];

export const comics: ComicItem[] = [
  {
    id: 1,
    title: "一秒反转的便利店",
    category: "恶搞反转",
    tags: ["反转", "短篇", "每日一更"],
    summary: "在便利店打工的主角，每次结账都会遭遇意想不到的神反转，笑点密集、脑洞清奇。",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20Korean%20gag%20comic%20cover%20illustration%20of%20a%20frazzled%20convenience%20store%20clerk%20being%20surprised%20by%20a%20giant%20turning%20sandwich%2C%20pop%20cartoon%20style%20with%20bold%20black%20outlines%2C%20expressive%20funny%20faces%2C%20warm%20coral%20and%20golden%20yellow%20palette%2C%20comic%20halftone%20texture%2C%20playful%20energetic%20composition&width=500&height=700&seq=comic-01&orientation=portrait",
    status: "连载中",
    updateTime: "今日 18:00",
    followers: "12.6万",
    episodes: 328,
    rating: 9.4,
    tagColor: "bg-accent-500 text-foreground-950",
  },
  {
    id: 2,
    title: "反转侦探事务所",
    category: "神展开",
    tags: ["侦探", "神展开", "烧脑"],
    summary: "看似普通的委托背后总藏着第三重反转，每一话都在挑战读者智商下限与上限。",
    cover: "https://readdy.ai/api/search-image?query=Cartoon%20illustration%20of%20a%20clumsy%20detective%20with%20a%20magnifying%20glass%20holding%20upside%20down%20case%20files%2C%20Korean%20gag%20manga%20cover%20style%2C%20bold%20outlines%2C%20mischievous%20expression%2C%20pop%20art%20color%20of%20coral%20and%20mustard%20yellow%2C%20dramatic%20comic%20layout%20with%20bursts%20and%20motion%20lines&width=500&height=700&seq=comic-02&orientation=portrait",
    status: "连载中",
    updateTime: "今日 16:30",
    followers: "8.9万",
    episodes: 156,
    rating: 9.6,
    tagColor: "bg-secondary-500 text-background-50",
  },
  {
    id: 3,
    title: "脑洞食堂",
    category: "脑洞大开",
    tags: ["脑洞", "美食", "奇幻"],
    summary: "一位总能把常识做进菜里的厨师，用离谱食材烹饪出让人沉默三秒再爆笑的美味。",
    cover: "https://readdy.ai/api/search-image?query=Funny%20cartoon%20cover%20of%20a%20chef%20cooking%20with%20a%20flying%20pizza%20and%20surprised%20diners%2C%20Korean%20gag%20comic%20illustration%2C%20bold%20outlines%2C%20vibrant%20orange%20and%20cream%20warm%20palette%2C%20whimsical%20brainstorm%20lightbulbs%20floating%20around%2C%20pop%20style%20energy&width=500&height=700&seq=comic-03&orientation=portrait",
    status: "连载中",
    updateTime: "今日 14:00",
    followers: "6.2万",
    episodes: 98,
    rating: 9.1,
    tagColor: "bg-primary-600 text-background-50",
  },
  {
    id: 4,
    title: "沙雕联盟日常",
    category: "魔性沙雕",
    tags: ["沙雕", "群像", "魔性"],
    summary: "一群把生活过成段子的大学生，每天都在用最离谱的方式互相坑队友，越坑越快乐。",
    cover: "https://readdy.ai/api/search-image?query=Cheerful%20cartoon%20group%20of%20young%20students%20tumbling%20in%20comic%20motion%2C%20Korean%20gag%20manhwa%20cover%2C%20bold%20thick%20outlines%2C%20bright%20warm%20yellow%20and%20coral%20colors%2C%20playful%20ridiculous%20expressions%2C%20dynamic%20pop%20composition%20with%20sparkles&width=500&height=700&seq=comic-04&orientation=portrait",
    status: "连载中",
    updateTime: "今日 12:00",
    followers: "15.3万",
    episodes: 412,
    rating: 9.3,
    tagColor: "bg-accent-600 text-foreground-950",
  },
  {
    id: 5,
    title: "社死现场编辑部",
    category: "爆笑日常",
    tags: ["职场", "社死", "爆笑"],
    summary: "职场新人每天上演花式社死现场，编辑部的同事们负责围观和补刀，笑到停不下来。",
    cover: "https://readdy.ai/api/search-image?query=Comic%20cover%20of%20a%20flustered%20office%20worker%20with%20paper%20flying%20everywhere%20while%20coworkers%20laugh%2C%20Korean%20gag%20manga%20style%2C%20bold%20outlines%2C%20warm%20beige%20and%20terracotta%20palette%2C%20humorous%20embarrassed%20faces%2C%20playful%20pop%20art%20with%20speed%20lines&width=500&height=700&seq=comic-05&orientation=portrait",
    status: "连载中",
    updateTime: "昨日 20:00",
    followers: "9.8万",
    episodes: 203,
    rating: 9.0,
    tagColor: "bg-secondary-600 text-background-50",
  },
  {
    id: 6,
    title: "每周一个神反转",
    category: "恶搞反转",
    tags: ["单元剧", "反转", "精选"],
    summary: "每周精选一部反转短篇，用三格到几十格不等的篇幅，把反转玩出花来。",
    cover: "https://readdy.ai/api/search-image?query=Playful%20comic%20illustration%20of%20a%20rotating%20slot%20machine%20spewing%20surprise%20gags%2C%20Korean%20gag%20comic%20cover%2C%20bold%20black%20outlines%2C%20vivid%20orange%20coral%20and%20golden%20tones%2C%20surprised%20character%20faces%2C%20comic%20burst%20shapes%2C%20energetic%20pop%20style&width=500&height=700&seq=comic-06&orientation=portrait",
    status: "已完结",
    updateTime: "昨日 10:00",
    followers: "7.5万",
    episodes: 64,
    rating: 9.5,
    tagColor: "bg-accent-500 text-foreground-950",
  },
  {
    id: 7,
    title: "平行宇宙逃生指南",
    category: "脑洞大开",
    tags: ["平行宇宙", "脑洞", "科幻"],
    summary: "主角每天醒来到达一个新世界，但每个世界的自己都在疯狂给另一个自己挖坑。",
    cover: "https://readdy.ai/api/search-image?query=Surreal%20funny%20cartoon%20of%20a%20person%20facing%20multiple%20mirrored%20clones%20doing%20silly%20poses%2C%20Korean%20gag%20manga%20cover%2C%20bold%20outlines%2C%20warm%20orange%20and%20teal-free%20golden%20palette%2C%20whimsical%20science%20fiction%20humor%2C%20pop%20comic%20composition&width=500&height=700&seq=comic-07&orientation=portrait",
    status: "连载中",
    updateTime: "昨日 15:00",
    followers: "5.4万",
    episodes: 87,
    rating: 9.2,
    tagColor: "bg-primary-600 text-background-50",
  },
  {
    id: 8,
    title: "反派也是打工人",
    category: "神展开",
    tags: ["反派", "职场", "神展开"],
    summary: "大反派每天早起打工还房贷，还要面对主角团花式捣乱，人间真实又离谱。",
    cover: "https://readdy.ai/api/search-image?query=Humorous%20cartoon%20cover%20of%20a%20villain%20in%20a%20suit%20carrying%20an%20office%20bag%20and%20coffee%2C%20Korean%20gag%20comic%20style%2C%20bold%20outlines%2C%20warm%20brown%20and%20coral%20palette%2C%20tired%20but%20silly%20expression%2C%20pop%20art%20with%20dramatic%20bursts&width=500&height=700&seq=comic-08&orientation=portrait",
    status: "连载中",
    updateTime: "今日 09:00",
    followers: "11.1万",
    episodes: 240,
    rating: 9.4,
    tagColor: "bg-secondary-500 text-background-50",
  },
  {
    id: 9,
    title: "猫主子盯上我了",
    category: "爆笑日常",
    tags: ["宠物", "日常", "爆笑"],
    summary: "一只智商超群又腹黑的猫，把铲屎官的生活搅得天翻地覆，萌中带梗笑料百出。",
    cover: "https://readdy.ai/api/search-image?query=Adorable%20cartoon%20of%20a%20mischievous%20fat%20cat%20staring%20at%20a%20confused%20human%2C%20Korean%20gag%20manhwa%20cover%2C%20bold%20outlines%2C%20warm%20cream%20background%20with%20coral%20and%20golden%20accents%2C%20funny%20suspicious%20cat%20expression%2C%20playful%20pop%20comic%20style&width=500&height=700&seq=comic-09&orientation=portrait",
    status: "连载中",
    updateTime: "昨日 19:00",
    followers: "13.7万",
    episodes: 301,
    rating: 9.3,
    tagColor: "bg-accent-600 text-foreground-950",
  },
];

export const hotRank = [
  { id: 10, rank: 1, title: "反转吧！倒霉蛋", followers: "21.4万", category: "恶搞反转", badge: "HOT" },
  { id: 11, rank: 2, title: "今天也是沙雕的一天", followers: "19.8万", category: "魔性沙雕", badge: "HOT" },
  { id: 12, rank: 3, title: "脑洞快递已送达", followers: "17.2万", category: "脑洞大开", badge: "" },
  { id: 13, rank: 4, title: "老板的十万个反转", followers: "14.6万", category: "爆笑日常", badge: "" },
  { id: 14, rank: 5, title: "沙雕同学会", followers: "12.1万", category: "魔性沙雕", badge: "NEW" },
];

export const featuredTopics = [
  {
    id: 20,
    title: "神展开专题：你以为猜中了，其实刚开始",
    desc: "精选 30 部神展开短篇，每一话都在你想不到的地方急转弯。",
    tag: "专题策划",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20collage%20style%20comic%20banner%20of%20surprised%20cartoon%20characters%20with%20mind%20blown%20effect%2C%20Korean%20gag%20comic%20theme%2C%20bold%20outlines%2C%20warm%20orange%20coral%20and%20golden%20yellow%20pop%20palette%2C%20dramatic%20burst%20shapes%20and%20question%20marks%2C%20playful%20energetic%20banner%20layout&width=900&height=600&seq=feat-01&orientation=landscape",
  },
  {
    id: 21,
    title: "反转合集：上一秒正经，下一秒离谱",
    desc: "把最经典的恶搞反转拉出来复盘，越看越上头。",
    tag: "热度精选",
    cover: "https://readdy.ai/api/search-image?query=Comic%20banner%20illustration%20of%20a%20character%20flipping%20a%20coin%20with%20dramatic%20reverse%20arrow%20effects%2C%20Korean%20gag%20manga%20style%2C%20bold%20outlines%2C%20warm%20mustard%20and%20coral%20pop%20colors%2C%20surprised%20and%20laughing%20faces%2C%20dynamic%20comic%20bursts&width=900&height=600&seq=feat-02&orientation=landscape",
  },
  {
    id: 22,
    title: "沙雕图鉴：成年人没有门槛",
    desc: "一本正经地记录沙雕生活，越真实越好笑。",
    tag: "魔性图鉴",
    cover: "https://readdy.ai/api/search-image?query=Playful%20comic%20banner%20of%20funny%20everyday%20life%20characters%20in%20silly%20poses%2C%20Korean%20gag%20comic%20style%2C%20bold%20outlines%2C%20warm%20cream%20and%20terracotta%20palette%2C%20humorous%20chaotic%20crowd%20scene%2C%20pop%20art%20with%20sparkle%20and%20motion%20lines&width=900&height=600&seq=feat-03&orientation=landscape",
  },
];

export const reviews = [
  { id: 1, name: "追更小能手", role: "恶搞反转控", text: "每天固定时间来打卡，反转剧情真的让人防不胜防，下班后的快乐源泉。", avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20smiling%20young%20man%20wearing%20headphones%2C%20Korean%20webtoon%20style%2C%20warm%20flat%20colors%2C%20friendly%20round%20face%2C%20minimal%20background&width=120&height=120&seq=ava-01&orientation=squarish" },
  { id: 2, name: "沙雕研究员", role: "脑洞爱好者", text: "这里的脑洞比我的黑眼圈还深，每话都刷新我对离谱的认知。", avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20laughing%20young%20woman%20with%20glasses%2C%20Korean%20webtoon%20style%2C%20warm%20flat%20colors%2C%20friendly%20expression%2C%20minimal%20background&width=120&height=120&seq=ava-02&orientation=squarish" },
  { id: 3, name: "熬夜追番人", role: "神展开粉", text: "反转又反转的剧情谁懂啊，经常一口气追到天亮，根本停不下来。", avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20happy%20young%20man%20with%20short%20hair%2C%20Korean%20webtoon%20style%2C%20warm%20flat%20colors%2C%20playful%20expression%2C%20minimal%20background&width=120&height=120&seq=ava-03&orientation=squarish" },
  { id: 4, name: "爆笑收集器", role: "魔性沙雕党", text: "魔性程度满分，上班摸鱼看两眼嘴角就压不住了，已被同事举报。", avatar: "https://readdy.ai/api/search-image?query=Cute%20cartoon%20avatar%20of%20a%20giggling%20young%20woman%20with%20ponytail%2C%20Korean%20webtoon%20style%2C%20warm%20flat%20colors%2C%20friendly%20face%2C%20minimal%20background&width=120&height=120&seq=ava-04&orientation=squarish" },
];

export const faqs = [
  { q: "韩国歪歪漫画多久更新一次？", a: "我们的恶搞反转与脑洞漫画每日更新，热门连载一般会在工作日固定时段更新，部分单元剧与专题每周更新。你可以在站内查看每部漫画的更新时间与连载状态，方便安排追更节奏。" },
  { q: "看漫画需要付费或注册吗？", a: "站内大部分恶搞反转、神展开与魔性沙雕内容都可以免费在线追更，无需注册。部分加更、抢先看或专题精选可能需要关注或参与站内活动解锁，具体以页面标注为准。" },
  { q: "如何找到最新的反转剧情更新？", a: "你可以在首页「今日更新」板块查看当天新更的漫画，也可以按「恶搞反转」「神展开」「脑洞大开」等分类筛选，或使用顶部搜索框直接检索你感兴趣的漫画名称与标签。" },
  { q: "内容适合什么年龄的读者？", a: "韩国歪歪漫画以恶搞反转、脑洞沙雕和爆笑日常为主，整体风格轻松幽默，适合成年读者休闲追更。个别单元剧可能包含无厘头或夸张情节，建议根据自身喜好选择。" },
  { q: "能否推荐适合入坑的反转短篇？", a: "如果你刚开始追更，推荐从「一周一个神反转」「社死现场编辑部」这类单元剧入手，篇幅短、反转密、笑点足；想深入追连载，可以试试「一秒反转的便利店」和「反派也是打工人」。" },
  { q: "我想推荐或投稿漫画，怎么联系你们？", a: "欢迎通过页面底部的联系表单发送你的想法，也可以将素材或链接发送到联系邮箱。我们会定期筛选优质恶搞反转内容，并在站内策划专题收录。" },
];